import React, { useState } from 'react';
import {truncateText} from "../../common/utils/trucantedText"

export const ExpandableText = ({ comment, length }) => {
  
  const text = comment?.originalText || comment?.text ||  comment || "";
  const hasTruncatedText = text.length > length;
  const [allText, setAllText] = useState(false);

  const truncatedText = hasTruncatedText ? truncateText(comment, length) : text;

  return (
    <p style={{ fontSize: '14px', fontWeight: 400 }}>
      {hasTruncatedText ? (
        allText ? (
          <span>
            {text} <a onClick={() => setAllText(false)}>Menos</a>
          </span>
        ) : (
          <span>
            {truncatedText} <a onClick={() => setAllText(true)}>Más</a>
          </span>
        )
      ) : (
        <span>{text}</span>
      )}
    </p>
  );
};